import { render, staticRenderFns } from "./crateInventory.vue?vue&type=template&id=5ce62c5a"
import script from "./crateInventory.vue?vue&type=script&lang=js"
export * from "./crateInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports